import { AuthContext } from "@sagecentral/core-ui";
import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";

type RequireAuthProps = {
    children: JSX.Element,
    redirectTo?: string,
    returnToPath?: string
};


const RequireAuth: React.FunctionComponent<RequireAuthProps> = (props) => {
    const location = useLocation();
    const auth = useContext(AuthContext);
    const { children } = props;
    const returnToPath = props.returnToPath ?? `${location.pathname}${location.search}`;
    const redirectTo = props.redirectTo ?? '/login';

    return auth.isAuthenticated() ? children : <Navigate to={redirectTo} state={{ returnToPath: returnToPath }} />;
};

export default RequireAuth;
